

// eslint-disable-next-line import/prefer-default-export
export const getFilterStyle = theme => ({
  dateWrapper: {
    display: 'flex',
  },
  dateSelectorBtn: {
    height: '2.5rem',
    fontFamily: theme.typography.fontFamily,
    padding: '0.063rem 0.813rem 0.063rem 0.563rem',
    border: `1px solid ${theme.palette.secondary['300']}`,
    borderRadius: '0.375rem',
    color: theme.palette.secondary['900'],
    backgroundColor: theme.palette.white,
    fontSize: '0.875rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'all 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    '&:hover': {
      border: `1px solid ${theme.palette.primary.main}`,
    },
    '&.open': {
      border: `1px solid ${theme.palette.primary.main}`,
    },
  },
  filterIcon: {
    width: '1.063rem',
    height: '1.063rem',
    marginRight: '0.563rem',
    fill: theme.palette.secondary['300'],
  },
});
